import rfdc from 'rfdc'
import merge from 'lodash/merge'

const clone = rfdc()

export function immutableMerge(destination, ...sources) {
  const _destination = clone(destination)
  const _sources = sources.map((s) => clone(s))
  return merge(_destination, ..._sources)
}

export function objectToArray(object = {}, labelProp = 'label', valueProp = 'value') {
  return Object.entries(object).map(([key, value]) => ({ [labelProp]: key, [valueProp]: value }))
}

export function arrayToObject(array = [], labelProp = 'label', valueProp = 'value') {
  return Array.isArray(array) && array.reduce((acc, it) => ({ ...acc, [it[labelProp]]: it[valueProp] }), {})
}

export function compareWithTrailingCharacters(a, b) {
  const LC = String.fromCharCode(0xffff)
  return a.replace(/\W/g, LC).localeCompare(b.replace(/\W/g, LC))
}

export function isObject(a) {
  return typeof a === 'object' && !Array.isArray(a)
}
